module.exports = __webpack_public_path__ + "static/media/postas-de-dourada.6769d5cd.jpg";